module.exports = __webpack_public_path__ + "static/img/coverRight.015c420.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coverRight.png
// module id = rIdo
// module chunks = 3